// The composer's files for the component's `selectedChat`: attach, remove, retry, and the
// notices for files that could not be attached. A component that may have no conversation
// yet (the welcome screen) overrides `chatForAttachments` to create one.
import { mapActions, mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters("oliverChatBotV2", {
      attachmentDrafts: "currentAttachmentDrafts",
      attachmentNotices: "currentAttachmentNotices",
      attachmentsCreating: "currentAttachmentsCreating",
    }),
  },
  methods: {
    ...mapActions("oliverChatBotV2", [
      "addAttachments",
      "removeAttachment",
      "retryAttachment",
      "dismissAttachmentNotices",
    ]),
    async chatForAttachments() {
      return this.selectedChat?.id || null;
    },
    async handleFilesSelected(files) {
      const chatId = await this.chatForAttachments();
      if (!chatId) return;
      this.addAttachments({ chatId, files });
    },
    handleRemoveAttachment(id) {
      this.removeAttachment(id);
    },
    handleRetryAttachment(id) {
      if (!this.selectedChat) return;
      this.retryAttachment({ chatId: this.selectedChat.id, id });
    },
    handleDismissNotices() {
      if (this.selectedChat)
        this.dismissAttachmentNotices(this.selectedChat.id);
    },
  },
};
